module.exports = __webpack_public_path__ + "img/21_49.e21eb5ee.png";